export default __webpack_public_path__ + "static/media/snow.de2cc8d1.svg";